import React, { useState, useEffect } from "react";
import "./PostDetails.css";

import db from "./firebase";
import PostSelf from "./PostSelf";
import firebase from "firebase";

const PostDetails = (props) => {
  const [post, setPost] = useState("");
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);

  useEffect(() => {
    db.collection("posts")
      .doc(props.match.params.id)
      .get()
      .then((snapshot) => setPost(snapshot.data()));
  }, [props.match.params.id]);

  useEffect(() => {
    let unsubscribe;
    if (props.match.params.id) {
      unsubscribe = db
        .collection("posts")
        .doc(props.match.params.id)
        .collection("comment")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          setComments(snapshot.docs.map((doc) => doc.data()));
        });
    }
    return () => {
      unsubscribe();
    };
  }, [props.match.params.id]);

  const postComment = (event) => {
    event.preventDefault();
    db.collection("posts")
      .doc(props.match.params.id)
      .collection("comment")
      .add({
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        text: comment,
        username: props.user.displayName,
      });
    setComment("");
  };

  return (
    <div
      className='flex flex-col md:w-1/2 xs:w-11/12 justify-center mt-7
     items-center mx-auto border-1 bg-color text-gray-300 border-white'>
      <PostSelf
        comments={comments}
        key={post.image}
        type={post.type}
        text={post.text}
        date={post.date}
        location={post.location}
        image={post.image}
      />

      {post.details && (
        <div className='flex-col flex justify-start p-2 mb-1 border-b-1'>
          <h6 className='md:px-4 xs:px-2 '>More Details</h6>
          <p className='font-mono md:px-5 xs:px-3'>{post.details}</p>
        </div>
      )}

      {comments.length === 0 ? "No Comments" : "Comments Here"}

      <div className='h-36 mt-2 overflow-auto scrollbar-hide'>
        {comments.map((comment) => (
          <div className='flex items-start px-6 justify-star w-full'>
            <span className='whitespace-nowrap'>
              {comment.username} ={">"}
            </span>
            <span className='ml-5 '>{comment.text} </span>
          </div>
        ))}
      </div>

      {!props.user ? (
        <h1>Login to add comment</h1>
      ) : (
        <form className='flex justify-between w-full py-2 px-3 mt-4'>
          <input
            value={comment}
            className='flex-1 border-1 border-color  md:p-2 xs:p-3 text-color'
            onChange={(e) => setComment(e.target.value)}
            placeholder='add comment here'
          />
          <button
            type='submit'
            disabled={!comment}
            className='flex-0 p-2 px-3 font-semibold bg-color text-gray-300 border-1 border-l-0 border-white'
            onClick={postComment}>
            <span>Post</span>
          </button>
        </form>
      )}
    </div>
  );
};

export default PostDetails;
